/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'feedback-collector.anonymous': 'Este comentario se envía de forma anónima. Atlassian no podrá ponerse en contacto contigo directamente en relación con estos comentarios',
  'feedback-collector.anonymous.title': 'Comentario anónimo',
  'feedback-collector.can-be-contacted.label': 'Sí, los equipos de Atlassian pueden ponerse en contacto conmigo para obtener información sobre mis experiencias y mejorar los productos y servicios de Atlassian. Acepto la <a>Política de privacidad de Atlassian</a>.',
  'feedback-collector.cancel-button.label': 'Cancelar',
  'feedback-collector.default.custom.textarea.label': '¿Qué te pasa por la cabeza?',
  'feedback-collector.enrol-in-research.label': 'Me gustaría participar en la investigación de productos',
  'feedback-collector.feedback-title': 'Danos tu opinión',
  'feedback-collector.form.bug.label': 'Describe el error o la incidencia',
  'feedback-collector.form.comment.label': 'Cuéntanos qué piensas',
  'feedback-collector.form.empty.label': 'Selecciona una opción',
  'feedback-collector.form.question.label': '¿Qué te gustaría saber?',
  'feedback-collector.form.suggestion.label': 'Dinos qué te gustaría mejorar',
  'feedback-collector.option.bug.label': 'Informar de un error',
  'feedback-collector.option.comment.label': 'Dejar un comentario',
  'feedback-collector.option.default.label': 'Seleccionar comentarios',
  'feedback-collector.option.default.placeholder': 'Elegir uno',
  'feedback-collector.option.question.label': 'Plantear una pregunta',
  'feedback-collector.option.suggestion.label': 'Sugerir una mejora',
  'feedback-collector.required.fields.summary': 'Los campos obligatorios están marcados con un asterisco',
  'feedback-collector.submit-button.label': 'Enviar comentarios',
  'feedback-collector.success-flag.description': 'Tus comentarios son muy útiles y nos ayudan a mejorar continuamente nuestros productos.',
  'feedback-collector.success-flag.title': '¡Gracias!',
  'feedback-collector.summary-placeholder': 'Cuéntanos qué piensas',
  'proforma-form-builder.feedback-icon-label': 'Comentarios',
  'proforma-form-builder.give-feedback': 'Enviar comentarios'
};